import { getCircularReplacer } from '@kariusdx/utils';
import { Logger } from './AnalyticsInterface';
import { isServerSide, VerboseLoggingOn } from './AnalyticsUtil';

export const ConsoleLogger: Logger = {
  name: 'Console',
  logEvent: (name, props) => log('log', name, props),
  logWarn: (name, props) => log('warn', name, props),
  logError: (name, props) => log('error', name, props),
};

const log = (severity: 'log' | 'warn' | 'error', name: string, props: object) => {
  if (!VerboseLoggingOn) return;

  if (isServerSide()) {
    const jsonLog = { name: name, ...props };
    console[severity](JSON.stringify(jsonLog, getCircularReplacer(), 2));
  } else {
    const group = '🪵____' + name + '_____🪵';
    console.group(group);
    console[severity]('%c' + new Date().toLocaleString() + '     ' + name);
    if (props) console[severity](props);
    console.groupEnd();
  }
};
